// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-3ZKsKX7z clearfix","box_r":"box_r-9CbJrZfZ","d_box":"d_box-223O9uMz"};